export const cards = [
  {
    id: 1,
    firstTitle: "Newsandevents.news1title1",
    secoundTitle: "Newsandevents.news1title2",
    details: ["Newsandevents.news1short"],
    content: "Newsandevents.news1content",
    image: "https://lepenecmonitoringsolutions.eu/img/kickoff-card.jpg",
    gradient: "linear-gradient(to right bottom, #2DB964, #14532D)",
    images: [
      { src: "https://lepenecmonitoringsolutions.eu/img/kickoff-card.jpg", alt: "kickoff 1" },
      { src: "https://lepenecmonitoringsolutions.eu/img/kickoff1-card.jpg", alt: "kickoff 2" },
      { src: "https://lepenecmonitoringsolutions.eu/img/kickoff2-card.jpg", alt: "kickoff 3" },
    ],
  },
  {
    id: 2,
    firstTitle: "Newsandevents.news2title1",
    secoundTitle: "Newsandevents.news2title2",
    details: ["Newsandevents.news2short"],
    content: "Newsandevents.news2content",
    image: "https://lepenecmonitoringsolutions.eu/img/telekom-card.jpg",
    gradient: "linear-gradient(to right bottom, #2DB964, #14532D)",
    images: [
      { src: "https://lepenecmonitoringsolutions.eu/img/telekom-card.jpg", alt: "telekom 1" },
      { src: "https://lepenecmonitoringsolutions.eu/img/telekom1-card.jpg", alt: "telekom 2" },
    ],
  },
  {
    id: 3,
    firstTitle: "Newsandevents.news3title1",
    secoundTitle: "Newsandevents.news3title2",
    details: ["Newsandevents.news3short"],
    content: "Newsandevents.news3content",
    image: "/img/news3.1.jpg",
    gradient: "linear-gradient(to right bottom, #2DB964, #14532D)",
    images: [

      { src: "/img/news3.1.jpg", alt: "news4 1" },
      { src: "/img/news3.2.jpg", alt: "news4 2" },
      { src: "/img/news3.3.jpg", alt: "news4 1" },
      { src: "/img/news3.4.jpg", alt: "news4 1" },
    ],
  },
  {
    id: 4,
    firstTitle: "Newsandevents.news4title1",
    secoundTitle: "Newsandevents.news4title2",
    details: ["Newsandevents.news4short"],
    content: "Newsandevents.news4content",
    image: "https://lepenecmonitoringsolutions.eu/img/news4.1.png", // Updated to absolute URL
    gradient: "linear-gradient(to right bottom, #2DB964, #14532D)",
    images: [
      { src: "https://lepenecmonitoringsolutions.eu/img/news4.1.png", alt: "news4 2" }, // Updated
      { src: "https://lepenecmonitoringsolutions.eu/img/news4.2.png", alt: "news4 1" }, // Updated
      { src: "https://lepenecmonitoringsolutions.eu/img/news4.3.png", alt: "news4 2" }, // Updated
      { src: "https://lepenecmonitoringsolutions.eu/img/news4.4.png", alt: "news4 1" }, // Updated
    ],
  },
  {
    id: 5,
    firstTitle: "Newsandevents.news5title1",
    secoundTitle: "Newsandevents.news5title2",
    details: ["Newsandevents.news5short"],
    content: "Newsandevents.news5content",
    image: "/img/news5.1.jpg",
    gradient: "linear-gradient(to right bottom, #2DB964, #14532D)",
    images: [

      { src: "/img/news5.1.jpg", alt: "news5 2" },
      { src: "/img/news5.2.jpg", alt: "news5 1" },
    ],
  },
  {
    id: 6,
    firstTitle: "Newsandevents.news6title1",
    secoundTitle: "Newsandevents.news6title2",
    details: ["Newsandevents.news6short"],
    content: "Newsandevents.news6content",
    image: "/img/news6.1.jpg",
    gradient: "linear-gradient(to right bottom, #2DB964, #14532D)",
    images: [

      { src: "/img/news6.1.jpg", alt: "news6 2" },
      { src: "/img/news6.2.jpg", alt: "news6 1" },
      { src: "/img/news6.3.jpg", alt: "news6 2" },
      { src: "/img/news6.4.jpg", alt: "news6 1" },
      { src: "/img/news6.5.jpg", alt: "news6 2" },
      { src: "/img/news6.6.jpg", alt: "news6 1" },
    ],
  },
  {
    id: 7,
    firstTitle: "Newsandevents.news7title1",
    secoundTitle: "Newsandevents.news7title2",
    details: ["Newsandevents.news7short"],
    content: "Newsandevents.news7content",
    image: "/img/news7.1.jpg",
    gradient: "linear-gradient(to right bottom, #2DB964, #14532D)",
    images: [

      { src: "/img/news7.1.jpg", alt: "news7 2" },
      { src: "/img/news7.2.jpg", alt: "news7 1" },
      { src: "/img/news7.3.jpg", alt: "news7 2" },
      { src: "/img/news7.4.jpg", alt: "news7 1" },
    ],
  },
  {
    id: 8,
    firstTitle: "Newsandevents.news8title1",
    secoundTitle: "Newsandevents.news8title2",
    details: ["Newsandevents.news8short"],
    content: "Newsandevents.news8content",
    image: "/img/news8.1.png",
    gradient: "linear-gradient(to right bottom, #2DB964, #14532D)",
    images: [

      { src: "/img/news8.1.png", alt: "news8 2" },
      { src: "/img/news8.2.png", alt: "news8 1" },
      { src: "/img/news8.3.png", alt: "news8 2" },
      { src: "/img/news8.4.png", alt: "news8 1" },
    ],
  },
  {
    id: 9,
    firstTitle: "Newsandevents.news9title1",
    secoundTitle: "Newsandevents.news9title2",
    details: ["Newsandevents.news9short"],
    content: "Newsandevents.news9content",
    image: "/img/news9.7.jpg",
    gradient: "linear-gradient(to right bottom, #2DB964, #14532D)",
    images: [
      { src: "/img/news9.1.jpg", alt: "news9 1" },
      { src: "/img/news9.2.jpg", alt: "news9 2" },
      { src: "/img/news9.3.jpg", alt: "news9 3" },
      { src: "/img/news9.4.jpg", alt: "news9 4" },
      { src: "/img/news9.5.jpg", alt: "news9 1" },
      { src: "/img/news9.6.jpg", alt: "news9 2" },
      { src: "/img/news9.7.jpg", alt: "news9 3" },
      { src: "/img/news9.8.jpg", alt: "news9 4" },
      { src: "/img/news9.9.jpg", alt: "news9 3" },
      { src: "/img/news9.10.jpg", alt: "news9 4" },
    ],
  },  
  {
    id: 10,
    firstTitle: "Newsandevents.news10title1",
    secoundTitle: "Newsandevents.news10title2",
    details: ["Newsandevents.news10short"],
    content: "Newsandevents.news10content",
    image: "/img/news10.1.jpg",
    gradient: "linear-gradient(to right bottom, #2DB964, #14532D)",
    images: [
      { src: "/img/news10.1.jpg", alt: "news10 1" },
      { src: "/img/news10.2.jpg", alt: "news10 2" },
    ],
  },  
  {
    id: 11,
    firstTitle: "Newsandevents.news11title1",
    secoundTitle: "Newsandevents.news11title2",
    details: ["Newsandevents.news11short"],
    content: "Newsandevents.news11content",
    image: "/img/news11.1.jpg",
    gradient: "linear-gradient(to right bottom, #2DB964, #14532D)",
    images: [
      { src: "/img/news11.1.jpg", alt: "news11 1" },
      { src: "/img/news11.2.jpg", alt: "news11 2" },
      { src: "/img/news11.3.jpg", alt: "news11 3" },
    ],
  }, 
  {
    id: 12,
    firstTitle: "Newsandevents.news12title1",
    secoundTitle: "Newsandevents.news12title2",
    details: ["Newsandevents.news12short"],
    content: "Newsandevents.news12content",
    image: "/img/news12.1.jfif",
    gradient: "linear-gradient(to right bottom, #2DB964, #14532D)",
    images: [
      { src: "/img/news12.1.jfif", alt: "news12 1" },
      { src: "/img/news12.2.jfif", alt: "news12 2" },
    ],
  },
  {
    id: 13,
    firstTitle: "Newsandevents.news13title1",
    secoundTitle: "Newsandevents.news13title2",
    details: ["Newsandevents.news13short"],
    content: "Newsandevents.news13content",
    image: "/img/news13.1.jpg",
    gradient: "linear-gradient(to right bottom, #2DB964, #14532D)",
    images: [
      { src: "/img/news13.1.jpg", alt: "news13 1" },
      { src: "/img/news13.2.jpg", alt: "news13 2" },
      { src: "/img/news13.3.jpg", alt: "news13 3" },
      { src: "/img/news13.4.jpg", alt: "news13 4" },
    ],
  },
];

export const getCardById = (id) => {
  return cards.find(card => card.id === id);
};